import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLayoutStore = defineStore('layout', () => {
  const showHeader = ref(true);
  const transitionName = ref('slide-left');
  const noTransitionRoutes = ['Login']; // 白名单
  // const isMobile = ref(window.innerWidth <= 768);
  const isMobile = ref(true);

  const updateShowHeader = (routeName) => {
    showHeader.value = !noTransitionRoutes.includes(routeName);
  };

  const updateTransitionName = (newName, oldName, routes) => {
    if (noTransitionRoutes.includes(newName) || noTransitionRoutes.includes(oldName)) {
      transitionName.value = null; // 禁用过渡效果
    } else {
      const toIndex = routes.findIndex(r => r.name === newName);
      const fromIndex = routes.findIndex(r => r.name === oldName);
      transitionName.value = toIndex < fromIndex ? 'slide-right' : 'slide-left';
    }
  };

  const setIsMobile = (value) => {
    isMobile.value = value;
    console.log('isMobile:????????????',isMobile.value)

  };

  return {
    showHeader,
    transitionName,
    isMobile,
    updateShowHeader,
    updateTransitionName,
    setIsMobile,
  };
});
